import {Button, message, Modal, Tabs} from 'antd';
import {formatTimestamp} from "../../helpers/time";
import {formatFileSize, getId} from "../../helpers/file";

export const showUsageInfo = () => {
  const uid = getId();
  
  // 重新统计函数
  const handleRefreshStats = () => {
    message.info('正在重新统计中，请稍后...');
    fetch('/img/trigger', { method: 'GET' })
      .then(res => res.json())
      .then(data => {
        if (data.success || data.isSuccess) {
          message.success('任务已触发，十分钟内完成');
        } else {
          message.error(data.message || '重新统计失败，请稍后重试');
        }
      })
      .catch(() => {
        message.error('重新统计失败，请稍后重试');
      });
  };
  
  // 获取在线情况
  const fetchOnlineInfo = fetch('/img/onlineInfo').then(res => res.json());
  
  // 获取存储统计
  const fetchStorageStats = fetch('/img/stat').then(res => res.json());
  
  Promise.all([fetchOnlineInfo, fetchStorageStats])
    .then(([onlineData, storageData]) => {
      const items = [
        {
          key: '1',
          label: '在线情况',
          children: (
            <>
              {
                Object.entries(onlineData)
                  .map(([key, value]) => 
                    <p key={key}>
                      {key == uid ? '当前设备' : key}: <b>{formatTimestamp(value as string)}</b>
                    </p>
                  )
              }
            </>
          ),
        },
        {
          key: '2',
          label: '存储统计',
          children: (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <p style={{ color: '#666', fontSize: '12px', margin: 0 }}>
                  * 离线统计，非实时更新
                </p>
                <Button size="small" type="primary" onClick={handleRefreshStats}>
                  点此重新统计
                </Button>
              </div>
              {storageData ? (
                Object.entries(storageData).map(([key, value]) => (
                  <p key={key}>
                    {key === 'totalSize' ? '总存储大小' : key}: <b>
                      {key === 'totalSize' && typeof value === 'number' 
                        ? formatFileSize(value)  as any
                        : value}
                    </b>
                  </p>
                ))
              ) : (
                <p>暂无存储统计数据</p>
              )}
            </div>
          ),
        },
      ];

      Modal.info({
        title: '使用情况',
        width: 600,
        content: (
          <Tabs defaultActiveKey="1" items={items} />
        ),
      });
    })
    .catch(error => {
      console.error('获取使用情况失败:', error);
      Modal.error({
        title: '错误',
        content: '获取使用情况失败，请稍后重试',
      });
    });
};